import {Step} from 'react-joyride';

export interface TourLink {
  label: string;
  url: string;
}

export interface SectionTextEntry {
  title?: string;
  description?: string;
  image?: string;
  link?: TourLink;
}

export interface TourStepData {
  section: string;
  title?: string;
  description?: string;
  image?: string;
  link?: TourLink;
}

interface StepConfigEntry {
  target: string;
  key: string;
}

interface BuildStepsOptions {
  autoOpenFirst?: boolean;
}

export function buildSteps(
  config: StepConfigEntry[],
  texts: Record<string, SectionTextEntry>,
  section: string,
  options: BuildStepsOptions = {},
): Step[] {
  const {autoOpenFirst = false} = options;
  return config.map(({target, key}, index) => {
    const entry = texts[key] ?? {};
    const data: TourStepData = {
      section,
      title: entry.title,
      description: entry.description,
      image: entry.image,
      link: entry.link,
    };
    return {
      target,
      content: '',
      data,
      disableBeacon: autoOpenFirst && index === 0,
    };
  });
}
